@if (state.selectedCriteriaDate) {
  @switch (state.selectedCriteriaDate.code) {
    @case (inputCriteriaDateCode.GREATER_OR_EQUAL) {
      <div
        class="input-criteria-date-wrapper"
        data-cy="input-criteria-date-greater-or-equal">
        <span class="input-criteria-date-text"
        data-cy="input-criteria-date-greater-or-equal-text">{{state.selectedCriteriaDate.resultPrefix}}</span>
        <ng-container *ngTemplateOutlet="startDate"></ng-container>
      </div>
    }
    @case (inputCriteriaDateCode.LESS_OR_EQUAL) {
      <div
        class="input-criteria-date-wrapper"
        data-cy="input-criteria-date-less-or-equal">
        <span class="input-criteria-date-text"
        data-cy="input-criteria-date-less-or-equal-text">{{state.selectedCriteriaDate.resultPrefix}}</span>
        <ng-container *ngTemplateOutlet="endDate"></ng-container>
      </div>
    }
    @case (inputCriteriaDateCode.BETWEEN_INTERVAL) {
      <div
        class="input-criteria-date-wrapper"
        data-cy="input-criteria-date-between-interval">
        <span class="input-criteria-date-text"
        data-cy="input-criteria-date-between-interval-start-date-text">{{state.selectedCriteriaDate.resultPrefix}}</span>
        <ng-container *ngTemplateOutlet="startDate"></ng-container>
        <span class="input-criteria-date-text"
        data-cy="input-criteria-date-between-interval-end-date-text">to</span>
        <ng-container *ngTemplateOutlet="endDate"></ng-container>
      </div>
    }
  }
} @else {
  <app-select-dropdown
    [dropdownDefaultButtonText]="inputCriteriaDateConfiguration.dropdownDefaultButtonText"
    [dropdownData]="inputCriteriaDateConfiguration.dropdownData"
    (selectedOption)="selectedOptionHandler($event)"
  data-cy="input-criteria-date-select-option"></app-select-dropdown>
}

<ng-template #startDate>
  <app-input-datepicker class="input-criteria-date-datepicker"
    (inputStateChange)="manageRequestedDateInputStateChange($event)"
    (closedDatepicker)="inputStartDateHandler($event)"
    [baseCypressTag]="'input-criteria-date-datepicker-start-date'"
    [maxDate]="setStartDateMaxDate()"
  [alternateBackground]="true"></app-input-datepicker>
</ng-template>

<ng-template #endDate>
  <app-input-datepicker class="input-criteria-date-datepicker"
    data-cy="input-criteria-date-datepicker-end-date"
    (inputStateChange)="manageRequestedDateInputStateChange($event)"
    (closedDatepicker)="inputEndDateHandler($event)"
    [baseCypressTag]="'input-criteria-date-datepicker-end-date'"
    [minDate]="setEndDateMinDate()"
  [alternateBackground]="true"></app-input-datepicker>
</ng-template>

